import { matchPath } from 'react-router-dom';

import * as ROUTES from '#client/constants/routes';

const APP_SECTION_ROUTES = {
  account: [
    ROUTES.accountSettings,
    ROUTES.download,
    ROUTES.help
  ],
  assistant: [
    ROUTES.assistantUI,
    '/guide/*'
  ],
  banking: [
    ROUTES.entityBanking
  ],
  business: [
    ROUTES.billing,
    ROUTES.entities,
    ROUTES.entityProfile,
    ROUTES.entityOrders,
    ROUTES.entitySubscriptions
  ],
  compliance: [
    ROUTES.entityComplianceAmendments,
    ROUTES.entityComplianceAnnualReports,
    ROUTES.entityComplianceBeneficialOwnership,
    ROUTES.entityComplianceBusinessLicenses,
    ROUTES.entityComplianceMeetingMinutes,
    ROUTES.entityComplianceTrademarks,
    ROUTES.entityWorryFreeCompliance
  ],
  documents: [
    ROUTES.entityBusinessDocuments,
    ROUTES.entityDocumentTemplates
  ],
  education: [
    ROUTES.education
  ],
  growth: [
    ROUTES.entityMarketingTools
  ],
  home: [
    ROUTES.entity,
    ROUTES.dashboard,
    ROUTES.logout
  ],
  insights: [
    ROUTES.entityZenlabs
  ],
  tax_services: [
    ROUTES.taxServices
  ],
  finance_hub: [
    ROUTES.entityFinanceHub
  ],
  money: [
    ROUTES.entityMoney
  ]
};

/**
 * Returns the app section based on the given pathname.
 *
 * @param {string} pathname - The input pathname to match against APP_SECTION_ROUTES.
 * @returns {string} The matching page section or 'unknown', if no match is found.
 */
function getAppSection(pathname) {
  const section = Object.entries(APP_SECTION_ROUTES).find(
    ([, routes]) => routes.find((route) => matchPath(route, pathname))
  )?.[0];

  return section || 'unknown';
}

export { getAppSection };
